export { SliderArrow } from './SliderArrow'
